import { useTranslation } from "react-i18next";

import { ChartCard, DonutChart } from "@/components/Elements/Charts";
import ListStatisticsCardExtra from "@/components/ListStatistics/ListStatisticsCardExtra";
import {
  useListStatistics,
  useListDonutChartSelected,
} from "@/components/ListStatistics/ListStatisticsHooks";
import {
  REFERENTIAl_STATES_ENDPOINTS,
  useReferentialStates,
} from "@/entities/referential/referential-states";
import { useTranslateNumber } from "@/modules/translate";

const STATS_DATA_KEY = "states";
const FILTER_KEY = "state";

const ObservationsStateDonutChart = () => {
  const { t } = useTranslation();
  const { translateNumber } = useTranslateNumber();

  const { getState } = useReferentialStates(
    REFERENTIAl_STATES_ENDPOINTS.OBSERVATION
  );

  const { loading, fetching, statsData } = useListStatistics({
    statsDataKey: STATS_DATA_KEY,
    filterKey: FILTER_KEY,
  });

  const chartData = statsData
    .map(({ state, count }) => {
      const stateObj = getState(state, "value");
      return stateObj
        ? { name: stateObj.value, value: count, color: stateObj.color }
        : undefined;
    })
    .filter(Boolean);

  const { selectedLegend, onLegendSelectChange } = useListDonutChartSelected({
    filterKey: FILTER_KEY,
    chartData,
  });

  return (
    <ChartCard
      title={t("observation:statistics.state.title")}
      extra={<ListStatisticsCardExtra filterKey={FILTER_KEY} />}
    >
      <DonutChart
        id="count-per-state"
        data={chartData}
        loading={loading}
        fetching={fetching}
        controlled={{ selectedLegend }}
        onLegendSelectChange={onLegendSelectChange}
        formatName={(stateValue) =>
          getState(stateValue, "value")?.name ?? stateValue
        }
        formatTooltipValue={translateNumber}
      />
    </ChartCard>
  );
};

export default ObservationsStateDonutChart;
